import { api } from '@/config'
import type { AppParam } from '@/types/appParams'

const BASE_URL = 'adm/app_params/'

export async function getParams(): Promise<AppParam[] | null> {
  try {
    const res = await api.get<AppParam[]>(BASE_URL)
    return res.data ?? null
  } catch (err) {
    logger.error('Failed to fetch app params', err)
    return null
  }
}
